// TODO: #646 refactor

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import { S3_DOWNLOAD_PATH } from '@config/config';
import colors from '@theme/colors';

const FileContainer = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0 0 10px 0;
`;

const A = styled.a`
  text-decoration: none;
  color: ${colors.PRIMARY};
  padding-left: 10px;
`;

export default class FileList extends Component {
  render() {
    return (
      <div>
        <FileContainer>
          {this.props.files.map((file, index) => (
            <li key={index}>
              <A
                href={`${S3_DOWNLOAD_PATH}${file}?access_token=${this.props.token}`}
                download
              >
                {file}
              </A>
            </li>
          ))}
        </FileContainer>
      </div>
    );
  }
}

FileList.propTypes = {
  files: PropTypes.array.isRequired,
  token: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./components/molecules/fileList/FileList.js